import { FormatType } from "./types";

export const FORMATS: FormatType[] = ["csv", "json"];
